export default __webpack_public_path__ + "static/media/darkGreenMarker.0bd460f1.svg";